import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guard/auth.guard';
import { UserService } from './shared/services/user.service';
import { Error404Component } from './web/sessions/404.component';

const routes: Routes = [
    {
        path: 'admin',
        loadChildren: './layout/layout.module#LayoutModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'login',
        loadChildren: './login/login.module#LoginModule'
    },
    /*{
        path: '',
        //loadChildren: './login/login.module#LoginModule'
        loadChildren: './coming-soon/coming-soon.module#ComingSoonModule'
    },*/
    {
        path: '',
        loadChildren: './web/web.module#WebModule'
        //loadChildren: './login/login.module#LoginModule'
    },
    /*{
        path: 'web-portal',
        loadChildren: './web/web.module#WebModule'
        //loadChildren: './login/login.module#LoginModule'
    },*/

    //{ path: '**', component: Error404Component }
];

@NgModule({
    imports: [RouterModule.forRoot(routes,{useHash:false})],
    exports: [RouterModule],
    providers: [AuthGuard, UserService]
})
export class AppRoutingModule {}
